import { render, staticRenderFns } from "./StorePaypalSettingsForm.vue?vue&type=template&id=4655283a&"
import script from "./StorePaypalSettingsForm.vue?vue&type=script&lang=js&"
export * from "./StorePaypalSettingsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports